// extracted by mini-css-extract-plugin
export var heroSection = "hero-module--heroSection--T7dF6";
export var heroLogo = "hero-module--heroLogo--n7BmQ";
export var heroLogoWhite = "hero-module--heroLogoWhite--m+A+2";
export var heroImage = "hero-module--heroImage--sVS5C";